import axios, { get, post, upload } from './axios'

// eslint-disable-next-line no-unused-vars
import qs from 'qs'
const pathname = location.pathname;
const host = location.host;
let appDomain = 'https://youxueketang.anoah.com';
if(pathname.includes('/test/') || host.includes('localhost')) {
  appDomain = 'https://edu-test1.anoah.com';
} else if(pathname.includes('/mirror/')) {
    appDomain = 'https://edu-m1.anoah.com';
  }
console.log('appDomain', appDomain);
window.process = process;
class Http {
  constructor (opts = {}) {
    return this.fetch(Object.entries(opts))
  }

  fetch (opts) {
    opts.forEach(([key, val]) => {
      let url = !/^http/.test(val.url) ? appDomain + val.url : val.url
      let params = {
        url: url,
        options: val.options || { headers: axios.defaults.headers }
      }
      if (val.method.toUpperCase() === 'GET') {
        this[key] = (data, opt) => this._get(Object.assign(params, opt && {url: opt.url, options: opt.options } || {}, { data }))
      } else if (val.method.toUpperCase() === 'POST') {
        this[key] = (data, opt) => this._post(Object.assign(params, opt && {url: opt.url, options: opt.options } || {}, { data }))
      }
    })
  }

  _get ({ url, data, options }) {
    return get(url, data, options)
  }

  _post ({ url, data, options }) {
    // eslint-disable-next-line no-mixed-operators
    let contentType = options.headers && options.headers['Content-Type'] || axios.defaults.headers['Content-Type']
    // if (data && /form/.test(contentType)) {
    //     data = qs.stringify(data);
    // }
    return post(url, data, options)
  }
}

export default Http
